export function preloadAsset(url: string, type: string = 'script'): void {
  const preloadLink = document.createElement('link');
  preloadLink.href = url;
  preloadLink.rel = 'preload';
  preloadLink.as = type;
  document.getElementsByTagName('head')[0].appendChild(preloadLink);
}

export function preloadImage(url: string | null | undefined): void {
  if (url == null || url.length === 0) return;
  new Image().src = url;
}
